<div #priceTagRef [ngClass]="{
    '_map-marker': true,
    '_map-marker-selected': (selected$ | async)
}"
     (mouseenter)="focusListing(listing.listingId)"
     (mouseleave)="focusListing('')"
>
    <ng-container *ngIf="listing?.operator?.logoUrl">
        <app-operator-logo [width]="120" [height]="90" [operator]="listing.operator"></app-operator-logo>
    </ng-container>
    <app-booking-price-range *ngIf="listing.priceRange" [priceRange]="listing.priceRange"></app-booking-price-range>
    <app-booking-price *ngIf="listing.fees && listing?.fees?.bookingFee?.amountMicros > 0"
                       [fees]="listing.fees"></app-booking-price>

</div>
